import React, { useState } from 'react';
import { FullscreenModal } from '../../../common/fullscreenModal/FullscreenModal';
import {
  Badge,
  ButtonPrimary,
  Loader,
  ModalContent,
  ModalHeader,
  Input,
  Label,
} from '@skf/bt-wind-rail-commonlibrary';
import { useTranslation } from 'react-i18next';
import style from './TurbineManagementDelete.module.scss';
import { useDispatch } from 'react-redux';
import {
  deleteWindFarm,
  deleteTurbine,
  deleteAsset,
  deleteBearing,
} from '../../../../store/taxonomy/actions';
import { useToast } from '../../../../hooks/useToast';
import {
  WindTaxonomy,
  TaxonomySystemInfoAdminCompleted,
  TaxonomyAssetInfoAdmin,
  TaxonomyBearingInfoAdmin,
} from '../../../../store/taxonomy/types';
import {} from '../../../../store/users/actions';

interface ITurbineManagementDeleteProps {
  taxonomySelected?: string;
  turbine?: TaxonomySystemInfoAdminCompleted;
  windFarm?: WindTaxonomy;
  asset?: TaxonomyAssetInfoAdmin;
  bearing?: TaxonomyBearingInfoAdmin;
  onClose: () => void;
}

export const TurbineManagementDelete: React.FunctionComponent<ITurbineManagementDeleteProps> = ({
  taxonomySelected,
  turbine,
  windFarm,
  asset,
  bearing,
  onClose,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { addToast } = useToast();
  const [isFetching, setFetching] = useState<boolean>(false);
  const [taxonomyName, setTaxonomyName] = useState<string | undefined>('');
  const onClickClose = () => !isFetching && onClose();

  const showDeleteInProgressToastr = (item: string, itemId: string) => {
    addToast({
      status: 'warning',
      message: t(`${item}Deleting`).replace('@', itemId),
      timeout: 7000,
    });
    return onClose();
  };

  const deleteFailedToastr = (item: string, itemId: string) => {
    addToast({
      status: 'danger',
      message: t(`${item}DeletingFailed`).replace('@', itemId),
      timeout: 7000,
    });
  };

  const deleteToastrOk = (item: string) => {
    addToast({
      status: 'ok',
      message: t(`delete${item}Ok`),
      timeout: 7000,
    });
  };

  const onClickSubmitWindFarm = () => {
    const toastrWindfarmId: string =
      windFarm?.taxonomyCustomer.plantUnitId?.toString() || '';
    showDeleteInProgressToastr('windfarm', toastrWindfarmId);
    const deleteWindfarmOk = () => {
      deleteToastrOk('WindFarm');
    };
    const deleteWindfarmFailed = () => {
      deleteFailedToastr('windfarm', toastrWindfarmId);
    };
    dispatch(deleteWindFarm(windFarm, deleteWindfarmOk, deleteWindfarmFailed));
    setFetching(true);
  };

  const onClickSubmitTurbine = () => {
    const toastrTurbineId = turbine?.sectionSystemId || '';
    showDeleteInProgressToastr('turbine', toastrTurbineId);
    const deleteTurbineOk = () => {
      deleteToastrOk('Turbine');
    };
    const deleteTurbineFailed = () => {
      deleteFailedToastr('turbine', toastrTurbineId);
    };
    dispatch(
      deleteTurbine(
        turbine?.sectionSystemKey,
        deleteTurbineOk,
        deleteTurbineFailed
      )
    );
    setFetching(true);
  };

  const onClickSubmitAsset = () => {
    const toastrAssetId = asset?.assetId || '';
    showDeleteInProgressToastr('asset', toastrAssetId);
    const deleteAssetOk = () => {
      deleteToastrOk('Asset');
    };
    const deleteAssetFailed = () => {
      deleteFailedToastr('asset', toastrAssetId);
    };
    dispatch(deleteAsset(asset?.assetKey, deleteAssetOk, deleteAssetFailed));
    setFetching(true);
  };

  const onClickSubmitBearing = () => {
    const toastrBearingId = bearing?.assetId || '';
    showDeleteInProgressToastr('bearing', toastrBearingId);
    const deleteBearingOk = () => {
      deleteToastrOk('Bearing');
    };
    const deleteBearingFailed = () => {
      deleteFailedToastr('bearing', toastrBearingId);
    };
    dispatch(
      deleteBearing(bearing?.assetPartKey, deleteBearingOk, deleteBearingFailed)
    );
    setFetching(true);
  };

  let title =
    taxonomySelected === 'WindFarms'
      ? windFarm?.taxonomyCustomer?.plantUnitDescription
      : turbine?.sectionSystemId;
  title = taxonomySelected === 'Assets' ? asset?.assetId : title;
  title = taxonomySelected === 'Bearings' ? bearing?.position : title;

  let ckickFunction =
    taxonomySelected === 'WindFarms'
      ? onClickSubmitWindFarm
      : onClickSubmitTurbine;
  ckickFunction =
    taxonomySelected === 'Assets' ? onClickSubmitAsset : ckickFunction;
  ckickFunction =
    taxonomySelected === 'Bearings' ? onClickSubmitBearing : ckickFunction;

  let labelDelete =
    taxonomySelected === 'WindFarms'
      ? t('WindFarm_to_delete')
      : t('Turbine_to_delete');
  labelDelete =
    taxonomySelected === 'Assets' ? t('asset_to_delete') : labelDelete;
  labelDelete =
    taxonomySelected === 'Bearings' ? t('bearing_to_delete') : labelDelete;

  let buttonDelete =
    taxonomySelected === 'WindFarms'
      ? t('delete_windfarm')
      : t('delete_turbine');
  buttonDelete =
    taxonomySelected === 'Assets' ? t('delete_asset') : buttonDelete;
  buttonDelete =
    taxonomySelected === 'Bearings' ? t('delete_Bearings') : buttonDelete;

  console.log('WINDFARM', windFarm);
  console.log('TURBINE', turbine);
  console.log('ASSET', asset);
  console.log('BEARING', bearing);
  console.log('taxonomySelected', taxonomySelected);

  return (
    <FullscreenModal onClose={onClickClose} className={style.modal}>
      <ModalHeader onClose={onClickClose}>{t('Delete')}</ModalHeader>
      <ModalContent className={style.content}>
        <>
          <Loader center show={isFetching} className={style.loader} />
          <div className={isFetching ? style.blur : ''}>
            <div className={style.container}>
              {t('You_are_trying_to_delete')}
              <Badge className={style.badge}>{title}</Badge>,{' '}
              {t('are_you_sure')}?
              <div className={style.containerTextDelete}>
                <Label className={style.labelCenter}>{labelDelete}</Label>
                <Input
                  placeholder={title}
                  onChange={(e) => setTaxonomyName(e)}
                ></Input>
              </div>
            </div>
            <div className={style.navigation}>
              <ButtonPrimary onClick={onClickClose} outline>
                {t('Cancel')}
              </ButtonPrimary>
              <ButtonPrimary
                disabled={!(taxonomyName === title)}
                onClick={() => ckickFunction()}
              >
                {buttonDelete}
              </ButtonPrimary>
            </div>
          </div>
        </>
      </ModalContent>
    </FullscreenModal>
  );
};
